import { resolveLanguageList } from '../tutorialSlug/utils/resolveLanguageList'
import type { TutorialSection } from '../types'
import { pickDefaultQuickStartLanguage } from '../utils/pickDefaultQuickStartLanguage'

import { documentationArticleUrlPath } from './documentationArticleUrlPath'

type DocumentationSectionRef = Pick<TutorialSection, 'path' | 'languages' | 'defaultLanguage'>

/**
 * Path string for documentation navigation, preserving preferredLanguage when available.
 */
export function documentationNavUrlPathForSection(target: DocumentationSectionRef, preferredLanguage?: string): string {
  const langs = resolveLanguageList(target)
  const lang =
    preferredLanguage && langs.includes(preferredLanguage)
      ? preferredLanguage
      : (target.defaultLanguage ?? pickDefaultQuickStartLanguage(langs))
  const pathParts = documentationArticleUrlPath(target.path).split('/').filter(Boolean)
  if (langs.length === 1) return pathParts.join('/')
  return `${pathParts.join('/')}/${lang}`
}
